import * as tslib_1 from "tslib";
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
/** A basic chevron icon */
var Chevron = (function () {
    function Chevron() {
        /** Chevron direction - "left" or "right" */
        this.dir = 'right';
    }
    tslib_1.__decorate([
        Input('chevron'),
        tslib_1.__metadata("design:type", String)
    ], Chevron.prototype, "dir", void 0);
    Chevron = tslib_1.__decorate([
        Component({
            changeDetection: ChangeDetectionStrategy.OnPush,
            selector: 'button[chevron-btn]',
            styles: [require('./Chevron.scss')],
            // tslint:disable-next-line:max-line-length
            template: '<svg [ngClass]="dir" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 438.533 438.533"><path d="M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064zm-74.801 122.908L204.71 361.736c-3.617 3.613-7.896 5.428-12.847 5.428-4.952 0-9.235-1.814-12.85-5.428l-29.121-29.13c-3.617-3.613-5.426-7.898-5.426-12.847 0-4.941 1.809-9.232 5.426-12.847l87.653-87.646-87.657-87.65c-3.617-3.612-5.426-7.898-5.426-12.845 0-4.949 1.809-9.231 5.426-12.847l29.121-29.13c3.619-3.615 7.898-5.424 12.85-5.424 4.95 0 9.233 1.809 12.85 5.424l129.622 129.621c3.613 3.614 5.42 7.898 5.42 12.847.001 4.951-1.806 9.236-5.419 12.849z"/></svg>'
        })
    ], Chevron);
    return Chevron;
}());
export { Chevron };



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/Chevron/Chevron.ts
// module id = 30
// module chunks = 0 1